import PostsList from './features/posts/PostsList';
import AddPostForm from './features/posts/AddPostForm';
import SinglePostPage from './features/posts/SinglePostPage';
import EditPostForm from './features/posts/EditPostForm';
import Layout from './components/Layout';
import { Routes, Route, Navigate } from 'react-router-dom';
import UsersList from './features/users/UsersList';
import UserPage from './features/users/UserPage';

function App() {
	return (
		<Routes>
			<Route path='/' element={<Layout />}>
				<Route index element={<PostsList />} />
				<Route path='post'>
					<Route index element={<AddPostForm />} />
					<Route path=':postId' element={<SinglePostPage />} />
					<Route path='edit/:postId' element={<EditPostForm />} />
				</Route>
				<Route path='users'>
					<Route index element={<UsersList />} />
					<Route path=':userId' element={<UserPage />} />
				</Route>
				{/* 404 Route */}
				<Route path='*' element={<Navigate to='/' replace />} />
			</Route>
		</Routes>
	);
}

export default App;
